import { Component, OnInit } from '@angular/core';
import { FormArray, FormBuilder, FormControl, FormGroup, ReactiveFormsModule, Validators } from "@angular/forms";
import { GenericCharge } from "../../../models/GenericCharge";
import { Site } from "../../../models/Site";
import { ActivatedRoute, Router } from "@angular/router";
import { AlertDialogService } from "../../../services/alert-dialog.service";
import { MatDialog } from "@angular/material/dialog";
import { MissionService } from "../../../services/mission.service";
import { FlagService } from "../../../shared/services/flag.service";
import { EstablishmentService } from "../../../services/establishment.service";
import { AuthService } from "../../../services/auth.service";
import moment from "moment/moment";
import { FlagType } from "../../../shared/utils/enums";
import { displayImg, removeBlankAttributes } from "../../../shared/utils/utils.functions";
import { minRemunerationFor, parseRemuneration, remunerationValidator, REMUNERATION_MAX } from "../../../shared/utils/remuneration.validator";
import { ImageDialogComponent } from "../../../shared/image-dialog/image-dialog.component";
import {
  acceptationCandidantOptions,
  priorityMissionOptions,
  statusMissionOptions, typeContratOptions
} from "../../../shared/utils/data/etablissments-data";
import { MatFormField, MatLabel } from "@angular/material/form-field";
import { MatRadioButton, MatRadioGroup } from "@angular/material/radio";
import { NgClass, NgForOf, NgIf } from "@angular/common";
import { NgxIntlTelInputModule } from "@justin-s/ngx-intl-tel-input";
import { SharedModule } from "../../../shared/shared.module";
import { MatAutocompleteModule } from "@angular/material/autocomplete";
import { MatInputModule } from "@angular/material/input";

@Component({
  selector: 'app-agency-etab-missions-add',
  standalone: true,
  imports: [
    MatLabel,
    MatFormField,
    MatRadioButton,
    MatRadioGroup,
    NgForOf,
    NgIf,
    NgxIntlTelInputModule,
    ReactiveFormsModule,
    SharedModule,
    NgClass,
    MatAutocompleteModule,
    MatInputModule
  ],
  templateUrl: './agency-etab-missions-add.component.html',
  styleUrl: './agency-etab-missions-add.component.scss'
})
export class AgencyEtabMissionsAddComponent implements OnInit {
  imageUrls: string[] = [];
  id: number;
  errorMessageStartDate: string = '';
  errorMessageEndDate: string = '';
  formGroup: FormGroup = this.fb.group({
    etablissementId: ['', Validators.required],
    agencyId: ['', Validators.required],
    regionId: [null, Validators.required],
    adresseId: ['', Validators.required],
    missionTitle: [{ value: '', disabled: true }, Validators.required],
    // etatDefaut: ['', Validators.required],
    serviceAffectationId: [
      { value: <string | number>'', disabled: true },
      Validators.required,
    ],
    typeSecteurId: [<string | number>'', Validators.required],
    typePosteId: [
      { value: <string | number>'', disabled: true },
      Validators.required,
    ],
    fichePosteId: [''], // facultative (client clinique) : la mission peut être publiée sans fiche de poste
    typeposte: [''],
    region: [''],
    id: [''],
    isurgent: [''],
    serviceaffectation: [''],
    description: [
      '',
      [
        Validators.required,
        Validators.minLength(50),
        Validators.maxLength(1000),
      ],
    ],
    startdate: ['', Validators.required],
    starttime: ['', Validators.required],
    pauseTime: [0],
    enddate: [{ value: '', disabled: true }, Validators.required],
    endtime: ['', Validators.required],
    applySameHoursToAllDays: [true],
    dailyHours: this.fb.array([]),
    compensationproposednet: [
      0,
      // Min depends on compensationType (HOUR=10, DAY/MONTH=50) and a comma decimal is accepted.
      [Validators.required, remunerationValidator()],
    ],
    compensationType: ['DAY'],
    typecontat: [''],
    platformManagedBy: [''],
    primeprovided: [1500],
    ismealsprovidedbyestablishment: [false],
    isaccommodationprovidedbyestablishment: [false],
    isprimeprovided: [false],
    isthirteenthmonthprovided: [false],
    istakinginchargetravelingexpenses: [false],
    childrenunderone: [false],
    childrenagedonetothree: [false],
    childrenagedthreetoten: [false],
    patientsinorlsurgery: [false],
    patientsincardiacsurgery: [false],
    patientsinneurocerebralsurgery: [false],
    // Ajout des champs pour targetCandidate
    targetCandidate: this.fb.group({
      experienceYears: [0, [Validators.min(0), Validators.max(50)]],
      collaborationCount: [0, [Validators.min(0), Validators.max(100)]],
      //maxDistance: [0, [Validators.min(0), Validators.max(1000)]]
    }),
    isNotFragmentable: [false],
    accommodationconditions: [''],
    mealsconditions: [''],
    travelingconditions: [''],
    otherprimesconditions: [''],
    isaccommodationprovidedfromexterior: [false],
    ismealsprovidedfromexterior: [false],
    isotherprimeprovided: [false],
    photo1: '',
    photo2: '',
    photo3: '',
    photo4: '',
    photo5: '',
  });
  public name: string;

  // Computed array of mission days for per-day hours
  missionDays: { date: Date; label: string }[] = [];


  FraisPostList: GenericCharge[] = [
    {
      id: 1,
      type: 'checkbox',
      controlName: 'childrenunderone',
      label: "Enfants de moins d'un an",
      display: true,
      isSecond: false,
    },
    {
      id: 2,
      type: 'checkbox',
      controlName: 'childrenagedonetothree',
      label: 'Enfants agés de 1 à 3 ans',
      display: true,
      isSecond: false,
    },
    {
      id: 3,
      type: 'checkbox',
      controlName: 'childrenagedthreetoten',
      label: 'Enfants agés de 3 à 10 ans',
      display: true,
      isSecond: false,
    },
    {
      id: 4,
      type: 'checkbox',
      controlName: 'patientsinorlsurgery',
      label: 'Patients en chirurgie ORL',
      display: true,
      isSecond: false,
    },
    {
      id: 5,
      type: 'checkbox',
      controlName: 'patientsincardiacsurgery',
      label: 'Patients en chirurgie cardiaque',
      display: true,
      isSecond: false,
    },
    {
      id: 6,
      type: 'checkbox',
      controlName: 'patientsinneurocerebralsurgery',
      label: 'Patients en neurochirurgie cérébrale',
      display: true,
      isSecond: false,
    },
  ];

  ChargeList: GenericCharge[] = [
    {
      id: 1,
      type: 'checkbox',
      controlName: 'isaccommodationprovidedbyestablishment',
      label: 'Hébergement',
      display: true,
      isSecond: false,
    },
    {
      id: 3,
      type: 'radio',
      options: [
        { label: 'Au sein de l’établissement', value: false },
        { label: 'Extérieur (Hôtel ou location)', value: true },
      ],
      controlName: 'isaccommodationprovidedfromexterior',
      label: 'Prise en charge',
      display: false,
      isSecond: true,
    },
    {
      id: 2,
      type: 'textarea',
      controlName: 'accommodationconditions',
      label: 'Conditions de prise en charge',
      display: false,
      isSecond: true,
    },

    {
      id: 4,
      type: 'checkbox',
      controlName: 'ismealsprovidedbyestablishment',
      label: 'Repas',
      display: true,
      isSecond: false,
    },
    {
      id: 8,
      type: 'radio',
      options: [
        { label: 'Au sein de l’établissement', value: false },
        { label: 'Extérieur (restaurants et commerces)', value: true },
      ],
      controlName: 'ismealsprovidedfromexterior',
      label: 'Prise en charge',
      display: false,
      isSecond: true,
    },
    {
      id: 9,
      type: 'textarea',
      controlName: 'mealsconditions',
      label: 'Conditions de prise en charge',
      display: false,
      isSecond: true,
    },

    {
      id: 5,
      type: 'checkbox',
      controlName: 'istakinginchargetravelingexpenses',
      label: 'Frais de déplacement',
      display: true,
      isSecond: false,
    },
    {
      id: 10,
      type: 'textarea',
      controlName: 'travelingconditions',
      label: 'Conditions de prise en charge',
      display: false,
      isSecond: true,
    },

    {
      id: 6,
      type: 'checkbox',
      controlName: 'isprimeprovided',
      label: 'Prime d’installation',
      display: false,
      isSecond: false,
    },
    {
      id: 7,
      type: 'checkbox',
      controlName: 'isthirteenthmonthprovided',
      label: 'Treizième mois',
      display: false,
      isSecond: false,
    },

    {
      id: 11,
      type: 'checkbox',
      controlName: 'isotherprimeprovided',
      label:
        'Existe-t-il autres primes ou indemnités mensuelles ou annuelles en euros ? ',
      display: false,
      isSecond: false,
    },
    {
      id: 12,
      type: 'textarea',
      controlName: 'otherprimesconditions',
      label: 'Autres conditions',
      display: false,
      isSecond: true,
    },
  ];

  listUrls: any = {
    path: 'missions',
    label: 'Missions',
    children: [
      {
        path: 'add',
        label: 'Créer une mission',
      },
    ],
  };
  today = new Date();
  siteList: Site[] = [];
  affectationServiceList: any[] = [];
  fichePostesList: any[] = [];
  posteList: any[] = [];
  secteurList: any[] = [];
  filteredSecteurs: any[] = [];
  filteredPostes: any[] = [];
  secteurSearchCtrl = new FormControl('');
  posteSearchCtrl = new FormControl({ value: '', disabled: true });
  loading = false;
  /** True while an existing draft/mission is being fetched for edit → shows the loading overlay. */
  loadingMission = false;
  missionId: string;
  mission: any;
  agencyId: number = 0;

  constructor(
    private fb: FormBuilder,
    private router: Router,
    private alertDialogService: AlertDialogService,
    private dialog: MatDialog,
    private api: MissionService,
    private flag: FlagService,
    private route: ActivatedRoute,
    private establishmentService: EstablishmentService,
    private auth: AuthService,
  ) {
    try {
      this.agencyId = Number(localStorage.getItem('id'));
      console.log(this.agencyId);
      this.formGroup.get('agencyId')?.patchValue(this.agencyId);
    } catch (error) {
    }
    // Route params are read in ngOnInit via paramMap.subscribe (not snapshot in the
    // constructor) so navigating from /mission-by-establishment/A/B to .../C/D while
    // the component is already alive actually reloads the data — otherwise Angular
    // reuses the instance silently and the form keeps the old mission.
  }

  ngOnInit(): void {
    this.establishmentService.establishments$.subscribe({
      next: (etabs) => {
        if (!!etabs && etabs.length > 0) {
          this.name = etabs.find(e => e.id == this.id)?.name
        }
      }
    })

    this.formGroup.get('fichePosteId')?.disable();
    // moment()
    this.formGroup
      .get('serviceAffectationId')
      ?.valueChanges.subscribe((res) => {
        this.fichePostesList = this.affectationServiceList
          .filter((el) => el.id == res)[0]
          ?.fichePostes?.map((el: any) => {
            return {
              id: el.id,
              label: el.name,
            };
          });
      });

    // Subscribe to paramMap so that an in-place navigation from
    // /mission-by-establishment/A/B to .../C/D actually reloads the form. Snapshot
    // reads in the constructor would not re-fire — Angular reuses the same component
    // instance for these route hits, which was why the URL changed but the data
    // didn't refresh (notif-click bug).
    this.route.paramMap.subscribe(params => {
      const newEstablishmentId = Number(params.get('establishmentId') ?? 0);
      const newMissionId = params.get('missionId') ?? '';
      this.id = newEstablishmentId;
      this.missionId = newMissionId;
      this.formGroup.get('etablissementId')?.patchValue(this.id);

      // Reset mission-specific state in case we're swapping from one mission to another.
      this.mission = undefined;
      this.imageUrls = [];

      // Refresh dropdown sources + the mission body for the new ids.
      this.getRef();
      if (this.id) {
        this.getCurrentEstablishment();
        this.getSecteurs();
        this.getSites();
        if (this.missionId) {
          this.loadingMission = true;
          this.getMissionById();
        }
      }
    });
    this.formGroup.get('typecontat')?.valueChanges.subscribe((val) => {
      const installationIndex = this.ChargeList.findIndex((a) => a.id === 6);
      const thirdMonthIndex = this.ChargeList.findIndex((a) => a.id === 7);
      const otherIndex = this.ChargeList.findIndex((a) => a.id === 11);
      this.ChargeList[installationIndex].display =
        this.typeContract !== 'LIBERAL' && this.typeContract !== '';
      this.ChargeList[thirdMonthIndex].display =
        this.typeContract !== 'LIBERAL' && this.typeContract !== '';
      this.ChargeList[otherIndex].display =
        this.typeContract !== 'LIBERAL' && this.typeContract !== '';
      if (val === 'CDD' || val === 'CDI') {
        this.formGroup.get('isNotFragmentable')?.setValue(true);
        // CDD/CDI → rémunération mensuelle (salaire)
        this.formGroup.get('compensationType')?.setValue('MONTH');
      } else {
        // LIBERAL (Intérim) → rémunération journalière par défaut
        this.formGroup.get('compensationType')?.setValue('DAY');
      }
      if (val === 'CDI') {
        // CDI = Contrat à Durée Indéterminée → date de fin optionnelle
        this.formGroup.get('enddate')?.clearValidators();
      } else {
        // CDD et LIBERAL → date de fin obligatoire
        this.formGroup.get('enddate')?.setValidators([Validators.required]);
      }
      this.formGroup.get('enddate')?.updateValueAndValidity();
    });

    // Re-validate remuneration whenever the compensation unit changes (HOUR=10 vs DAY/MONTH=50).
    this.formGroup.get('compensationType')?.valueChanges.subscribe(() => {
      this.formGroup.get('compensationproposednet')?.updateValueAndValidity();
    });

    this.formGroup.get('startdate')?.valueChanges.subscribe((val) => {
      const inSevenDays = moment(new Date())
        .add(8, 'days')
        .format('YYYY-MM-DD');
      const isUrgent = moment(val).isBefore(inSevenDays);
      this.formGroup.get('isurgent')?.patchValue(isUrgent);

      if (isUrgent) {
        this.formGroup.get('isurgent')?.disable();
      } else {
        this.formGroup.get('isurgent')?.enable();
      }
    });

    this.formGroup.get('startdate')?.valueChanges.subscribe((res) => {
      if (res) {
        if (this.formGroup.get('enddate')?.disabled) {
          this.formGroup.get('enddate')?.enable();
        }
      } else {
        if (this.formGroup.get('enddate')?.enabled) {
          this.formGroup.get('enddate')?.disable();
          this.formGroup.get('enddate')?.patchValue('');
        }
      }
      // Regenerate mission days when start date changes
      this.generateMissionDays();
    });

    // Regenerate mission days when end date changes
    this.formGroup.get('enddate')?.valueChanges.subscribe(() => {
      this.generateMissionDays();
    });

    this.formGroup.get('applySameHoursToAllDays')?.valueChanges.subscribe((applySameHours) => {
      const perDayValidators = applySameHours ? [] : [Validators.required];
      this.dailyHoursFormArray.controls.forEach(group => {
        const startTimeControl = group.get('startTime');
        const endTimeControl = group.get('endTime');
        startTimeControl?.setValidators(perDayValidators);
        endTimeControl?.setValidators(perDayValidators);
        startTimeControl?.updateValueAndValidity({ emitEvent: false });
        endTimeControl?.updateValueAndValidity({ emitEvent: false });
      });

      // In per-day mode, per-day entries are the source of truth for times.
      // The main starttime/endtime controls must NOT block form validity — drop their
      // `required` validator and seed them from the first day so submission stays consistent.
      const mainStart = this.formGroup.get('starttime');
      const mainEnd   = this.formGroup.get('endtime');
      if (applySameHours) {
        mainStart?.setValidators([Validators.required]);
        mainEnd?.setValidators([Validators.required]);
      } else {
        mainStart?.clearValidators();
        mainEnd?.clearValidators();
        this.updateMainTimesFromDailyHours();
      }
      mainStart?.updateValueAndValidity({ emitEvent: false });
      mainEnd?.updateValueAndValidity({ emitEvent: false });
    });

    this.formGroup.get('typePosteId')?.valueChanges.subscribe((value) => {
      if (value) {
        const poste = this.posteList.find((p) => p.value === value);
        if (poste) {
          this.formGroup.get('typeposte')?.patchValue(poste.label);
        }
      }
    });

    this.formGroup.get('regionId')?.valueChanges.subscribe((value) => {
      if (value) {
        this.api.getRegionByCode(value).subscribe({
          next: (region) => {
            this.formGroup.get('region')?.patchValue(region.name);
          },
          error: () => {
          },
        });
      }
    });

    this.formGroup.get('parCollary')?.valueChanges.subscribe((value) => {
      if (value) {
        this.formGroup.get('parVousMeme')?.patchValue(!value);
      }
    });
    this.formGroup.get('parVousMeme')?.valueChanges.subscribe((value) => {
      if (value) {
        this.formGroup.get('parCollary')?.patchValue(!value);
      }
    });
    this.formGroup
      .get('serviceAffectationId')
      ?.valueChanges.subscribe((value) => {
        if (value) {
          this.formGroup.get('fichePosteId')?.enable();
        }
      });
    this.formGroup.get('typeSecteurId')?.valueChanges.subscribe((id) => {
      if (this.secteurList.find((s) => s.value === id)) {
        const secteurName = this.secteurList.find((s) => s.value === id).label;
        this.formGroup.get('serviceaffectation')?.patchValue(secteurName);
        this.getPostes(id);
      }
    });
    this.formGroup.get('adresseId')?.valueChanges.subscribe((id) => {
      const regionId: number = +this.siteList.find((s: Site) => s.id === id)
        ?.regionCode!;
      this.formGroup.get('regionId')?.patchValue(+regionId);
      this.getAffectations(id);
      if (!id) {
        if (this.formGroup.get('serviceAffectationId')?.enabled) {
          this.formGroup.get('serviceAffectationId')?.disable();
        }
      }
    });

    this.formGroup
      .get('isaccommodationprovidedbyestablishment')
      ?.valueChanges.subscribe((val) => {
        const conditionIndex = this.ChargeList.findIndex((a) => a.id === 2);
        const chargeIndex = this.ChargeList.findIndex((a) => a.id === 3);
        this.ChargeList[conditionIndex].display = val;
        this.ChargeList[chargeIndex].display = val;
      });

    this.formGroup
      .get('ismealsprovidedbyestablishment')
      ?.valueChanges.subscribe((val) => {
        const conditionIndex = this.ChargeList.findIndex((a) => a.id === 8);
        const chargeIndex = this.ChargeList.findIndex((a) => a.id === 9);
        this.ChargeList[conditionIndex].display = val;
        this.ChargeList[chargeIndex].display = val;
      });

    // traveling
    this.formGroup
      .get('istakinginchargetravelingexpenses')
      ?.valueChanges.subscribe((val) => {
        const conditionIndex = this.ChargeList.findIndex((a) => a.id === 10);
        this.ChargeList[conditionIndex].display = val;
      });

    // other
    this.formGroup
      .get('isotherprimeprovided')
      ?.valueChanges.subscribe((val) => {
        const conditionIndex = this.ChargeList.findIndex((a) => a.id === 12);
        this.ChargeList[conditionIndex].display = val;
      });

    // serviceAffectationId change
    this.formGroup
      .get('serviceAffectationId')
      ?.valueChanges.subscribe(async (val) => {
        this.imageUrls = [];
        if (val) {
          const serviceAffectation = await this.affectationServiceList.find(
            (a) => a.id === val
          );

          if (serviceAffectation && serviceAffectation.firstServicePhoto) {
            this.imageUrls.push(serviceAffectation.firstServicePhoto);
          }
          if (serviceAffectation && serviceAffectation.secondServicePhoto) {
            this.imageUrls.push(serviceAffectation.secondServicePhoto);
          }
        }
      });
  }

  getMissionById() {
    this.api.getMissionById(this.missionId).subscribe({
      next: (value) => {
        this.mission = value;
        this.mission.isNotFragmentable = !value.isfragmentable;
        this.formGroup.patchValue(this.mission);

        // Pre-populate autocomplete labels from the response's text fields
        if (value.typeSecteur) {
          this.secteurSearchCtrl.setValue(value.typeSecteur);
        }
        if (value.typePoste) {
          this.posteSearchCtrl.setValue(value.typePoste);
        }

        // #1 Modalité de rémunération: patchValue above fires the typecontat valueChanges,
        // which resets compensationType to DAY/MONTH — so restore the SAVED value here
        // (default DAY for drafts that carry none, e.g. email extraction).
        this.formGroup.get('compensationType')?.setValue(this.mission.compensationType || 'DAY');

        // #2 Surface the description error immediately (e.g. extracted draft < 50 chars)
        // instead of only disabling "Publier" silently.
        const descCtrl = this.formGroup.get('description');
        if (descCtrl?.invalid) {
          descCtrl.markAsTouched();
        }

        // #3 Legacy extracted drafts stored the pause only inside dailyHours (mission-level pause
        // left 0/null). Seed the main "Durée de pause" from the first day so it shows and re-saves.
        // Runs once on load, so it never overrides a value the user edits afterwards.
        if (!this.mission?.pauseTime && this.mission?.dailyHours?.length) {
          const firstPause = this.mission.dailyHours[0]?.pauseTime;
          if (firstPause) {
            this.formGroup.get('pauseTime')?.patchValue(firstPause, { emitEvent: false });
          }
        }

        this.loadingMission = false;
      },
      error: () => {
        this.loadingMission = false;
      },
    });
  }

  get startDate(): Date {
    return new Date(this.formGroup.get('startdate')?.value);
  }

  get typeContract(): string {
    return this.formGroup.get('typecontat')?.value;
  }

  isDurationLessThan24Hours(mission: any): boolean {
    const start = new Date(mission.startdate);
    const end = new Date(mission.enddate);
    const [startHours, startMinutes] = mission.starttime.split(':').map(Number);
    start.setHours(startHours, startMinutes, 0, 0);
    const [endHours, endMinutes] = mission.endtime.split(':').map(Number);
    end.setHours(endHours, endMinutes, 0, 0);
    const diffMilliseconds = end.getTime() - start.getTime();
    const diffHours = diffMilliseconds / (1000 * 60 * 60);
    return diffHours <= 24;
  }

  /** Error copy for the remuneration field, reflecting the active unit's minimum. */
  get remunerationErrorMessage(): string {
    const min = minRemunerationFor(this.formGroup.get('compensationType')?.value);
    return `La valeur minimum est de ${min} et la valeur maximum ${REMUNERATION_MAX} euro`;
  }

  /** Normalize the remuneration (comma decimal → number) in-place on a submission body. */
  private normalizeRemuneration(body: any): void {
    const parsed = parseRemuneration(body?.compensationproposednet);
    if (!isNaN(parsed)) {
      body.compensationproposednet = parsed;
    }
  }

  addMission() {
    const body = this.formGroup.getRawValue();
    body['isfragmentable'] = !body['isNotFragmentable'];
    if (this.isDurationLessThan24Hours(body)) {
      body['isfragmentable'] = false;
    }
    delete body['isNotFragmentable'];

    this.proceedWithMission();
  }

  proceedWithMission() {
    this.alertDialogService
      ?.openAlertModal(
        'success',
        "Publication d'une mission",
        'Êtes-vous sûr(e) de vouloir publier cette mission ?',
        'Oui',
        'Non',
        '700px',
        true
      )
      ?.subscribe((res) => {
        if (res) {
          // Update main times from dailyHours if not using same hours for all days
          this.updateMainTimesFromDailyHours();

          const body = this.formGroup.getRawValue();
          body['isfragmentable'] = !body['isNotFragmentable'];
          if (this.isDurationLessThan24Hours(body)) {
            body['isfragmentable'] = false;
          }
          delete body['isNotFragmentable'];
          this.normalizeRemuneration(body);
          body.startdate = moment(body.startdate).add(1, 'hours').format('yyyy-MM-DDT00:00:00');
          // Pour CDI/CDD la date de fin est optionnelle — ne pas formater si vide
          body.enddate = body.enddate
            ? moment(body.enddate).add(1, 'hours').format('yyyy-MM-DDT00:00:00')
            : null;

          // Add dailyHours if using different hours per day.
          // Invariant: dailyHours present <=> applySameHoursToAllDays === false. Deriving the flag
          // here (instead of reading a possibly-stale form value) also normalizes single-day and
          // legacy extracted drafts to the shape the UI always produces.
          const dailyHoursData = this.buildDailyHoursForSubmission();
          if (dailyHoursData) {
            body.dailyHours = dailyHoursData;
            body.applySameHoursToAllDays = false;
          } else {
            delete body.dailyHours;
            body.applySameHoursToAllDays = true;
          }

          body.agencyId = this.agencyId;
          console.log("BOOOOOOOOOOOOODY", body)

          this.loading = true;
          const apiKey: string = this.mission
            ? 'updateDraftPublishMission'
            : 'addMission';

          this.api[this.mission ? 'updateDraftPublishMission' : 'addMission'](
            body
          ).subscribe({
            next: () => {
              this.flag.displayFlag(
                'Mission ajoutée avec succès !',
                FlagType.success
              );
              this.router.navigate([`/agency/details-establishment/${this.id}`]);
              this.loading = false;
            },
            error: () => {
              this.flag.displayFlag(
                'Veuillez compléter les informations manquantes.',
                FlagType.error
              );
              this.loading = false;
            },
          });
        }
      });
  }

  draftMission() {
    const body = this.formGroup.getRawValue();
    const isCdiOrCdd = body.typecontat === 'CDI' || body.typecontat === 'CDD';
    const isCdi = body.typecontat === 'CDI';

    if (body.startdate == '') {
      this.errorMessageStartDate =
        'Pour enregistrer un brouillon, vous devez saisir la date du début de la mission.';
    }
    // Seul le CDI n'a pas de date de fin obligatoire (durée indéterminée)
    if (!isCdi && body.enddate == '') {
      this.errorMessageEndDate =
        'Pour enregistrer un brouillon, vous devez saisir la date de fin de la mission.';
    }

    const canProceed = body.startdate && (isCdi || body.enddate);
    if (canProceed) {
      this.errorMessageStartDate = '';
      this.errorMessageEndDate = '';
      body.establishmentId = body.etablissementId;
      body['isfragmentable'] = !body['isNotFragmentable'];
      if (!isCdiOrCdd && this.isDurationLessThan24Hours(body)) {
        body['isfragmentable'] = false;
      }
      delete body['isNotFragmentable'];
      this.normalizeRemuneration(body);

      if (body.startdate) {
        body.startdate = moment(body.startdate).add(1, 'hours').format('yyyy-MM-DDT00:00:00');
      }

      // Pour CDI/CDD la date de fin est optionnelle
      body.enddate = body.enddate
        ? moment(body.enddate).add(1, 'hours').format('yyyy-MM-DDT00:00:00')
        : null;

      // Update main times from dailyHours if not using same hours for all days
      this.updateMainTimesFromDailyHours();

      // Add dailyHours if using different hours per day.
      // Invariant: dailyHours present <=> applySameHoursToAllDays === false (also normalizes
      // single-day and legacy extracted drafts to the shape the UI always produces).
      const dailyHoursData = this.buildDailyHoursForSubmission();
      if (dailyHoursData) {
        body.dailyHours = dailyHoursData;
        body.applySameHoursToAllDays = false;
      } else {
        delete body.dailyHours;
        body.applySameHoursToAllDays = true;
      }

      this.loading = true;
      this.api[this.mission ? 'updateDraftMission' : 'draftMission'](
        removeBlankAttributes(body)
      ).subscribe({
        next: () => {
          this.flag.displayFlag(
            'Mission ajoutée avec succès !',
            FlagType.success
          );
          this.router.navigate([`/agency/details-establishment/${this.id}`]);
          this.loading = false;
        },
        error: () => {
          this.flag.displayFlag(
            'Veuillez compléter les informations manquantes.',
            FlagType.error
          );
          this.loading = false;
        },
      });
    }
  }

  getAffectations(id: number) {
    this.api.getAffectationBySiteId(id).subscribe({
      next: (res) => {
        if (this.formGroup.get('serviceAffectationId')?.disabled) {
          this.formGroup.get('serviceAffectationId')?.enable();
        }
        // Only offer visible services in the dropdown (hide isvisible === false).
        this.affectationServiceList = (res || []).filter((s: any) => s.isvisible !== false);
        if (this.mission) {
          this.formGroup
            .get('serviceAffectationId')
            ?.patchValue(this.mission?.serviceAffectationId);
        }
      },
    });
  }

  getPostes(id: number) {
    this.formGroup.get('typePosteId')?.patchValue('');
    this.posteSearchCtrl.setValue('');
    this.posteSearchCtrl.disable();
    this.api.getPostes(id).then((res) => {
      this.posteList = res.map((p: any) => ({
        value: p.id,
        label: p.name,
      }));
      this.filteredPostes = this.posteList;
      this.posteSearchCtrl.enable();
      this.formGroup.get('typePosteId')?.enable();
    });
  }

  getSecteurs() {
    this.api.getSecteurs().then((res) => {
      this.secteurList = res.map((s: any) => ({
        value: s.id,
        label: s.name,
      }));
      this.filteredSecteurs = this.secteurList;
    });
  }

  // --- Autocomplete filtering ---
  getSearchText(ctrl: FormControl): string {
    const val = ctrl.value;
    if (!val) return '';
    return typeof val === 'string' ? val : val.label || '';
  }

  filterSecteurs(query: string): void {
    const q = (typeof query === 'string' ? query : '').toLowerCase();
    this.filteredSecteurs = this.secteurList.filter(s => s.label.toLowerCase().includes(q));
  }

  filterPostes(query: string): void {
    const q = (typeof query === 'string' ? query : '').toLowerCase();
    this.filteredPostes = this.posteList.filter(p => p.label.toLowerCase().includes(q));
  }

  // --- Autocomplete selection handlers ---
  onSecteurSelected(event: any): void {
    const selected = event.option.value;
    if (!selected) return;
    if (selected.value === '__CREATE__') {
      this.createSecteur(selected.label);
      return;
    }
    this.formGroup.get('typeSecteurId')?.patchValue(selected.value);
    this.formGroup.get('serviceaffectation')?.patchValue(selected.label);
    this.getPostes(selected.value);
  }

  onPosteSelected(event: any): void {
    const selected = event.option.value;
    if (!selected) return;
    if (selected.value === '__CREATE__') {
      this.createPoste(selected.label);
      return;
    }
    this.formGroup.get('typePosteId')?.patchValue(selected.value);
    this.formGroup.get('typeposte')?.patchValue(selected.label);
  }

  // --- Create new entries on-the-fly ---
  createSecteur(name?: string): void {
    const finalName = (name || this.getSearchText(this.secteurSearchCtrl)).trim();
    if (!finalName) return;
    this.api.createSecteur(finalName).subscribe({
      next: (res: any) => {
        const newEntry = { value: res.id, label: res.name };
        if (!this.secteurList.find(s => s.value === res.id)) {
          this.secteurList.push(newEntry);
        }
        this.filteredSecteurs = this.secteurList;
        this.secteurSearchCtrl.setValue(newEntry as any);
        this.formGroup.get('typeSecteurId')?.patchValue(newEntry.value);
        this.formGroup.get('serviceaffectation')?.patchValue(newEntry.label);
        this.getPostes(newEntry.value);
      }
    });
  }

  createPoste(name?: string): void {
    const finalName = (name || this.getSearchText(this.posteSearchCtrl)).trim();
    const secteurId = this.formGroup.get('typeSecteurId')?.value;
    if (!finalName || !secteurId) return;
    this.api.createPoste(secteurId, finalName).subscribe({
      next: (res: any) => {
        const newEntry = { value: res.id, label: res.name };
        if (!this.posteList.find(p => p.value === res.id)) {
          this.posteList.push(newEntry);
        }
        this.filteredPostes = this.posteList;
        this.posteSearchCtrl.setValue(newEntry as any);
        this.formGroup.get('typePosteId')?.patchValue(newEntry.value);
        this.formGroup.get('typeposte')?.patchValue(newEntry.label);
      }
    });
  }

  // Check if the current search term has an exact match in the list
  secteurHasExactMatch(): boolean {
    const q = this.getSearchText(this.secteurSearchCtrl).trim().toLowerCase();
    return !q || this.secteurList.some(s => s.label.toLowerCase() === q);
  }

  posteHasExactMatch(): boolean {
    const q = this.getSearchText(this.posteSearchCtrl).trim().toLowerCase();
    return !q || this.posteList.some(p => p.label.toLowerCase() === q);
  }

  displaySecteur(option: any): string {
    if (typeof option === 'string') return option;
    return option?.label || '';
  }

  displayPoste(option: any): string {
    if (typeof option === 'string') return option;
    return option?.label || '';
  }

  getImage(images: any[]): void {
    for (let index = 0; index < 5; index++) {
      this.formGroup.get(`photo${index + 1}`)?.patchValue(images[index] || '');
    }
    // images.forEach((img, index) => {
    //   this.formGroup.get(`photo${index + 1}`)?.patchValue(img);
    // })
  }

  getRef() {
    this.api.getRefMission(this.id).subscribe({
      next: (ref) => {
        this.formGroup.get('missionTitle')?.patchValue(ref);
      },
    });
  }

  getSites() {
    this.establishmentService
      .getSiteByEstablishmentId(this.id, true)
      .subscribe({
        next: (value) => {
          //getSiteByEstablishmentId
          this.siteList = value.map((item: any) => {
            return {
              ...item,
              value: item.id,
              label: item.name,
            };
          });
          // Auto-select first site by default if none is selected
          if (this.siteList.length > 0 && !this.formGroup.get('adresseId')?.value) {
            // valueChanges on adresseId loads the affectation services
            this.formGroup.patchValue({ adresseId: this.siteList[0].id });
          }
        },
      });
  }

  getCurrentEstablishment() {
    this.establishmentService.getEstablishmentById(this.id).subscribe({
      next: (res) => {
        // this.siteList = res.adresses.map((item: any) => {
        //     return {
        //       value: item.id,
        //       label: item.name,
        //     }
        // })
      },
      error: (err) => {
      },
    });
  }

  goBack(): void {
    this.alertDialogService
      ?.openAlertModal(
        'success',
        'Quitter sans sauvegarder ?',
        'Vous avez saisi les informations pour créer une nouvelle mission, ' +
        'mais vous vous apprêtez à quitter la page sans sauvegarder. ' +
        'Toutes les modifications seront perdues. Êtes-vous sûr(e) de vouloir quitter sans sauvegarder ?',
        'Quitter sans Sauvegarder',
        'Revenir à la création',
        '700px',
        true
      )
      ?.subscribe((res) => {
        if (res) {
          this.router.navigateByUrl(`/agency/details-establishment/${this.id}`);
        }
      });
  }

  checkBoxChange(e: any, value: string) {
    this.formGroup.get('platformManagedBy')?.patchValue(value);
  }

  openImage(img: any) {
    const dialog = this.dialog.open(ImageDialogComponent, {
      backdropClass: 'bg-transparent',

      data: img,
    });
    dialog.afterClosed().subscribe((value) => {
      if (value) {
      }
    });
  }

  protected readonly statusMissionOptions = statusMissionOptions;
  protected readonly priorityMissionOptions = priorityMissionOptions;
  protected readonly acceptationCandidantOptions = acceptationCandidantOptions;
  protected readonly typeContratOptions = typeContratOptions;
  protected readonly displayImg = displayImg;

  // Getter for dailyHours FormArray
  get dailyHoursFormArray(): FormArray {
    return this.formGroup.get('dailyHours') as FormArray;
  }

  // Generate mission days array from start and end dates
  generateMissionDays(): void {
    const startDate = this.formGroup.get('startdate')?.value;
    const endDate = this.formGroup.get('enddate')?.value;

    if (!startDate || !endDate) {
      this.missionDays = [];
      this.clearDailyHoursArray();
      return;
    }

    const start = moment(startDate);
    const end = moment(endDate);

    if (end.isBefore(start)) {
      this.missionDays = [];
      this.clearDailyHoursArray();
      return;
    }

    this.missionDays = [];
    const current = start.clone();

    while (current.isSameOrBefore(end, 'day')) {
      const formattedDate = current.locale('fr').format('dddd D MMMM YYYY');
      this.missionDays.push({
        date: current.toDate(),
        label: formattedDate.charAt(0).toUpperCase() + formattedDate.slice(1)
      });
      current.add(1, 'day');
    }

    // Rebuild dailyHours FormArray to match the days
    this.rebuildDailyHoursArray();
  }

  // Clear the dailyHours FormArray
  clearDailyHoursArray(): void {
    while (this.dailyHoursFormArray.length > 0) {
      this.dailyHoursFormArray.removeAt(0);
    }
  }

  // Rebuild dailyHours FormArray based on missionDays
  rebuildDailyHoursArray(): void {
    this.clearDailyHoursArray();

    const defaultStartTime = this.formGroup.get('starttime')?.value || '';
    const defaultEndTime = this.formGroup.get('endtime')?.value || '';

    // Check if we have existing daily hours from a fetched mission
    const hasExistingDailyHours = this.mission && this.mission.dailyHours && this.mission.dailyHours.length > 0;

    for (const day of this.missionDays) {
      let startTime = defaultStartTime;
      let endTime = defaultEndTime;
      const defaultPauseTime = this.formGroup.get('pauseTime')?.value ?? (this.mission?.pauseTime ?? 0);
      let pauseTime: number | string = defaultPauseTime;

      if (hasExistingDailyHours) {
        const formattedDate = moment(day.date).format('YYYY-MM-DD');
        const existingDay = this.mission.dailyHours.find((dh: any) =>
          moment(dh.date).format('YYYY-MM-DD') === formattedDate
        );

        if (existingDay) {
          startTime = existingDay.startTime || defaultStartTime;
          endTime = existingDay.endTime || defaultEndTime;
          pauseTime = existingDay.pauseTime ?? defaultPauseTime;
        }
      }

      const applySameHours = this.formGroup.get('applySameHoursToAllDays')?.value;
      const validators = applySameHours ? [] : [Validators.required];

      const group = this.fb.group({
        date: [moment(day.date).format('YYYY-MM-DD')],
        startTime: [startTime, validators],
        pauseTime: [pauseTime],
        endTime: [endTime, validators]
      });

      this.dailyHoursFormArray.push(group);
    }

    // Subscribe to changes on the first day's times to sync with hidden starttime/endtime
    if (this.dailyHoursFormArray.length > 0) {
      const firstGroup = this.dailyHoursFormArray.at(0);
      firstGroup.get('startTime')?.valueChanges.subscribe((val: string) => {
        if (!this.formGroup.get('applySameHoursToAllDays')?.value) {
          this.formGroup.get('starttime')?.patchValue(val, { emitEvent: false });
        }
      });
      firstGroup.get('endTime')?.valueChanges.subscribe((val: string) => {
        if (!this.formGroup.get('applySameHoursToAllDays')?.value) {
          this.formGroup.get('endtime')?.patchValue(val, { emitEvent: false });
        }
      });
    }

    // After rebuilding, re-apply validator/sync state for the current mode so that
    // main starttime/endtime match the active source (per-day first entry vs. same-hours).
    const applySameHoursNow = this.formGroup.get('applySameHoursToAllDays')?.value;
    const mainStart = this.formGroup.get('starttime');
    const mainEnd   = this.formGroup.get('endtime');
    if (applySameHoursNow) {
      mainStart?.setValidators([Validators.required]);
      mainEnd?.setValidators([Validators.required]);
    } else {
      mainStart?.clearValidators();
      mainEnd?.clearValidators();
      this.updateMainTimesFromDailyHours();
    }
    mainStart?.updateValueAndValidity({ emitEvent: false });
    mainEnd?.updateValueAndValidity({ emitEvent: false });
  }

  // Build dailyHours data for API submission
  buildDailyHoursForSubmission(): any[] | null {
    const applySameHours = this.formGroup.get('applySameHoursToAllDays')?.value;

    // If same hours for all days or only one day, don't send dailyHours
    if (applySameHours || this.missionDays.length <= 1) {
      return null;
    }

    return this.dailyHoursFormArray.controls.map((control, index) => ({
      date: this.missionDays[index]?.date ? moment(this.missionDays[index].date).format('YYYY-MM-DD') : null,
      startTime: control.get('startTime')?.value,
      pauseTime: control.get('pauseTime')?.value || null,
      endTime: control.get('endTime')?.value
    }));
  }

  // Sync the (hidden) main starttime/endtime/pause from the first day — ONLY for a real multi-day
  // per-day mission, where the main controls are just a fallback. For a single day the main controls
  // ARE the visible, editable inputs, so they must never be overwritten from the derived dailyHours
  // array (that would clobber the user's edits). Single-day legacy pause is seeded once on load in
  // getMissionById() instead.
  updateMainTimesFromDailyHours(): void {
    const applySameHours = this.formGroup.get('applySameHoursToAllDays')?.value;

    if (!applySameHours && this.missionDays.length > 1 && this.dailyHoursFormArray.length > 0) {
      const firstDayGroup = this.dailyHoursFormArray.at(0);
      const firstStartTime = firstDayGroup.get('startTime')?.value;
      const firstEndTime = firstDayGroup.get('endTime')?.value;

      if (firstStartTime) {
        this.formGroup.get('starttime')?.patchValue(firstStartTime, { emitEvent: false });
      }
      if (firstEndTime) {
        this.formGroup.get('endtime')?.patchValue(firstEndTime, { emitEvent: false });
      }
      const firstPause = firstDayGroup.get('pauseTime')?.value;
      if (firstPause !== undefined && firstPause !== null) {
        this.formGroup.get('pauseTime')?.patchValue(firstPause, { emitEvent: false });
      }
    }
  }

}
